@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.stage {
  animation-duration: 300ms;
  animation-fill-mode: forwards;
  animation-name: fadeIn;
  animation-timing-function: ease-in-out;
  height: 100%;
  /*display: flex;*/
  opacity: 0;
  /* overflow: hidden; */
  position: relative;
  width: 100%;

  *,
  * * {
    pointer-events: none !important;
    user-select: none !important;
  }

  canvas {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
